{/* Auto-generated icon - do not edit */}
import React from 'react'

interface UserIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const UserIcon = React.forwardRef<SVGSVGElement, UserIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 154 139"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M95.5437 138.156C81.351 138.156 67.1577 138.087 52.9659 138.178C41.5557 138.251 30.1507 138.581 18.7418 138.66C15.532 138.66 12.3267 138.419 9.15272 137.943C2.31571 136.962 -0.404563 132.922 1.87229 126.404C3.42924 122.038 5.46389 117.857 7.93922 113.936C18.4269 97.1419 33.6865 86.2365 51.9746 79.2109C61.9028 75.3176 72.455 73.2462 83.1222 73.0962C99.0705 72.9578 113.752 76.996 126.29 87.4914C134.849 94.5585 141.844 103.321 146.832 113.223C148.22 115.99 149.785 118.693 150.897 121.569C151.965 124.224 152.711 126.997 153.121 129.828C153.669 134.07 151.3 136.882 147.055 137.416C144.094 137.817 141.111 138.04 138.121 138.084C123.929 138.149 109.736 138.115 95.5437 138.115V138.156ZM142.17 127.803C142.226 127.352 142.221 126.896 142.157 126.446C137.636 114.734 131.39 104.149 121.739 95.8573C114.294 89.4607 105.943 84.8575 96.0222 83.6091C84.5906 82.1713 73.2634 82.4726 62.0901 85.6133C40.9515 91.5548 24.0858 103.251 12.5362 122.106C11.2221 124.251 10.179 126.56 8.97055 128.862C9.33781 129.063 9.72102 129.233 10.1162 129.371C14.0708 130.238 18.0145 129.728 22.0028 129.506C30.2914 129.042 38.6028 128.843 46.9056 128.8C74.0693 128.661 101.233 128.671 128.397 128.542C132.919 128.518 137.433 128.068 142.172 127.803H142.17Z" fill={color}/>
<path d="M80.054 0.453541C90.989 0.187825 100.125 5.39469 107.061 14.8577C108.696 17.0888 110.669 19.1602 111.863 21.6072C114.532 27.0767 116.742 32.6955 115.324 39.0792C113.992 45.0736 112.256 50.8459 108.387 55.7593C101.506 64.4873 92.7342 69.8834 81.5231 71.2249C71.4315 72.4332 61.8361 70.9417 52.8772 66.2047C43.6499 61.3263 38.3999 53.4318 36.4939 43.2887C33.6251 28.0194 41.6324 14.325 54.2666 7.04399C61.912 2.63671 70.168 0.415397 80.054 0.453541ZM104.014 31.4757C104.515 27.6263 102.971 24.5522 100.578 21.7508C99.6445 20.6576 98.8004 19.4847 97.8286 18.4277C94.3109 14.6016 90.2998 11.5747 84.9643 10.7737C77.4841 9.53875 69.8049 10.543 62.8974 13.6597C54.2633 17.6209 47.8224 23.6599 46.3384 33.7015C44.6075 45.4157 50.667 55.8989 61.4438 59.3596C67.9015 61.3733 74.7204 61.965 81.4297 61.0937C90.6013 60.0463 101.397 50.6408 102.856 40.9871C103.332 37.8295 103.633 34.6449 104.014 31.4725V31.4757Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="153" height="139" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

UserIcon.displayName = 'UserIcon'
